import { createTheme } from "@mui/material";
import Montserrat from "./font/Montserrat-VariableFont_wght.ttf"
import MontserratItalic from "./font/Montserrat-Italic-VariableFont_wght.ttf"



const theme = createTheme({
  typography: {
    fontFamily: [
        'Montserrat',
      ].join(','),
	},
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Montserrat';
          font-style: normal;
          src: url(${Montserrat}) format('truetype');
          font-weight: 100 900;
        }
        @font-face {
          font-family: 'Montserrat';
          font-style: italic;
          src: url(${MontserratItalic}) format('truetype');
          font-weight: 100 900;
        }
      `,
    },
  },
  palette: {
    primary: {
      main: "#E6142D",
    },
    secondary: {
      main: "#671F2B",
    },
    background: {
      default: 'white',
    },
    darkgrey: {
      main: "#212429"
    },
    mediumgrey: {
      main: "#706F6F"
    },
    lightgrey: {
      main: "#E1E1E3"
    },
    twitterblue: {
      main: "#0381A2"
    }
  },
});

export default theme;